import { useEffect, useState } from "react";

import { getApplicationSection } from "@/lib/application";
import { useIsSelfService } from "@/lib/hook/useIsSelfService";

import { ApplicationSectionStatusType } from "../applicationSectionStatus";
import { ApplicationFull } from "../prisma";

export const useIsFormDisabled = (
  application: ApplicationFull,
  applicationSectionStatus: ApplicationSectionStatusType | null,
  isCompleted = false
) => {
  const isSelfService = useIsSelfService();
  const [isFormDisabled, setIsFormDisabled] = useState(
    applicationSectionStatus === ApplicationSectionStatusType.ReviewCompleted
  );

  useEffect(() => {
    if (isSelfService) {
      if (getApplicationSection(application)?.isDocumentPackGenerated) {
        setIsFormDisabled(true);
      } else {
        setIsFormDisabled(false);
      }
    } else if (isCompleted) {
      setIsFormDisabled(true);
    } else {
      setIsFormDisabled(
        applicationSectionStatus ===
          ApplicationSectionStatusType.ReviewCompleted && !isSelfService
      );
    }
  }, [application, applicationSectionStatus, isCompleted, isSelfService]);

  return { isFormDisabled };
};
